import { Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { AddLineButton, ChatbotCreateBomButton } from 'quotes/components';
import { IBaseQuote } from 'quotes/types';
import { Direction, Level } from 'theme/enums';

interface IProps {
  quote: IBaseQuote;
}

export const QuotePartListEmptyState = ({ quote }: IProps) => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();

  const onSubmitSuccess = () => {
    queryClient.invalidateQueries('customerQuoteParts');
  };

  return (
    <Stack direction={Direction.COLUMN} gap={2}>
      <Typography level={Level.TITLE_MD}>{t('labelEmptyQuotePartsMessage')}</Typography>
      <Stack direction={Direction.ROW} gap={2} justifyContent="center">
        <AddLineButton
          buttonLabel={t('buttonLabelAddPartNumber')}
          quote={quote}
          onSubmitSuccess={onSubmitSuccess}
        />
        <ChatbotCreateBomButton quoteId={quote.id} />
      </Stack>
    </Stack>
  );
};
